import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Lock = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="lock icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 10V6.5C5.5 2.91015 8.41015 0 12 0C15.5899 0 18.5 2.91015 18.5 6.5V10H19C20.1046 10 21 10.8954 21 12V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V12C3 10.8954 3.89543 10 5 10H5.5ZM8.5 6.5C8.5 4.567 10.067 3 12 3C13.933 3 15.5 4.567 15.5 6.5V10H8.5V6.5ZM13 17.2324C13.5978 16.8866 14 16.2403 14 15.5C14 14.3954 13.1046 13.5 12 13.5C10.8954 13.5 10 14.3954 10 15.5C10 16.2403 10.4022 16.8866 11 17.2324V19.5C11 20.0523 11.4477 20.5 12 20.5C12.5523 20.5 13 20.0523 13 19.5V17.2324Z"
    />
  </svg>
)
